module.exports = __webpack_public_path__ + "static/media/image7.baa5c275.png";